"use client";
import {
  createContext,
  type PropsWithChildren,
  useContext,
  useState,
} from "react";
import { type CustomFormModuleBody } from "@/components/site-builder/modules/CustomFormModule/types";
import { type FormBuilderFormEntity } from "@/types/form-builder";

export interface CustomFormContextProps {
  formBody: CustomFormModuleBody;
  formEntity: FormBuilderFormEntity;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

const defaultClientConfig = {
  formEntity: {},
  isSubmitting: false,
} as CustomFormContextProps;

export const CustomFormContext =
  createContext<CustomFormContextProps>(defaultClientConfig);

export function CustomFormContextProvider(
  props: PropsWithChildren<{
    value: Omit<CustomFormContextProps, "isSubmitting" | "setIsSubmitting">;
  }>,
) {
  const { value, children } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const contextValue: CustomFormContextProps = {
    ...value,
    isSubmitting,
    setIsSubmitting,
  };

  return (
    <CustomFormContext.Provider value={contextValue}>
      {children}
    </CustomFormContext.Provider>
  );
}

export function useCustomFormContext() {
  return useContext(CustomFormContext);
}
